import { storage } from "./firebaseconf";
import firebase from "./firebaseconf"

const uploadImage = (photo) => {
    const ref = firebase.storage().ref();
    const file = photo;
    const fileName = `${Date.now()}-${file.name}`;

    const metaData = {
        contentType: file.type
    }

    const task = ref.child(fileName).put(file, metaData);
    return task;
}

export default uploadImage;
